import { useMutation } from 'react-query';
import axios, { AxiosResponse, AxiosError } from 'libs/axios';
import { Template } from 'types/template';
import { Recorder } from 'types/recorder';

interface ChangeRecordersTag {
    tag: string;
    recorders: Recorder[];
}

export const useChangeRecordersTag = () => {
    return useMutation<AxiosResponse, AxiosError, ChangeRecordersTag>(
        ({ recorders, tag }) =>
            axios.post(`/api/ui/recorders/changeTag`, {
                ids: recorders.map((item) => item.id),
                tag
            })
    );
};

export const useDeleteRecorders = () => {
    return useMutation<AxiosResponse, AxiosError, Recorder[]>((recorders) =>
        axios.delete(
            `/api/ui/recorders?${recorders
                .map((item) => `ids=${item.id}`)
                .join('&')}`
        )
    );
};

export const useDeleteRecordersLogs = () => {
    return useMutation<AxiosResponse, AxiosError, Recorder[]>((recorders) =>
        axios.delete(
            `/api/ui/recorders/logs?${recorders
                .map((item) => `ids=${item.id}`)
                .join('&')}`
        )
    );
};

interface ChangeRecordersTemplate {
    template: Template;
    recorders: Recorder[];
}

export const useChangeRecordersTemplate = () => {
    return useMutation<AxiosResponse, AxiosError, ChangeRecordersTemplate>(
        ({ template, recorders }) =>
            axios.post(`/api/ui/recorders/changeTemplate`, {
                template: template.name,
                ids: recorders.map((item) => item.id)
            })
    );
};

interface ChangeRecordersState {
    enable: boolean;
    recorders: Recorder[];
}

export const useChangeRecordersState = () => {
    return useMutation<AxiosResponse, AxiosError, ChangeRecordersState>(
        ({ enable, recorders }) =>
            axios.post(`/api/ui/recorders/changeRecordingPermissions`, {
                enable,
                ids: recorders.map((item) => item.id)
            })
    );
};
